import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="task-bulk-assign"
//
// Drives the bulk-assign bar on the admin tasks page:
//   - shows the "X tasks selected" bar + Assign button when any row checkbox is checked
//   - master checkbox toggles all visible row checkboxes
//   - syncs hidden task_ids[] inputs on the assign form with the current selection
export default class extends Controller {
  static targets = ["actionBar", "count", "masterCheckbox", "itemCheckbox", "assignForm"]

  connect() {
    this.updateState()
  }

  toggleAll(event) {
    const checked = event.target.checked
    this.itemCheckboxTargets.forEach((cb) => {
      cb.checked = checked
    })
    this.updateState()
  }

  updateState() {
    const selected = this.selectedIds()
    if (this.hasCountTarget) this.countTarget.textContent = selected.length

    if (this.hasActionBarTarget) {
      if (selected.length > 0) {
        this.actionBarTarget.classList.remove("hidden")
        this.actionBarTarget.classList.add("flex")
      } else {
        this.actionBarTarget.classList.add("hidden")
        this.actionBarTarget.classList.remove("flex")
      }
    }

    if (this.hasMasterCheckboxTarget) {
      const all = this.itemCheckboxTargets
      const checked = all.filter((cb) => cb.checked)
      if (all.length === 0) {
        this.masterCheckboxTarget.checked = false
        this.masterCheckboxTarget.indeterminate = false
      } else if (checked.length === all.length) {
        this.masterCheckboxTarget.checked = true
        this.masterCheckboxTarget.indeterminate = false
      } else if (checked.length === 0) {
        this.masterCheckboxTarget.checked = false
        this.masterCheckboxTarget.indeterminate = false
      } else {
        this.masterCheckboxTarget.checked = false
        this.masterCheckboxTarget.indeterminate = true
      }
    }

    if (this.hasAssignFormTarget) {
      this.syncHiddenIds(this.assignFormTarget, selected)
    }
  }

  selectedIds() {
    return this.itemCheckboxTargets.filter((cb) => cb.checked).map((cb) => cb.value)
  }

  syncHiddenIds(form, ids) {
    form.querySelectorAll("input[data-bulk-id]").forEach((el) => el.remove())
    ids.forEach((id) => {
      const input = document.createElement("input")
      input.type = "hidden"
      input.name = "task_ids[]"
      input.value = id
      input.dataset.bulkId = "true"
      form.appendChild(input)
    })
  }
}
